import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const ReportsPage = () =>
  import('@/apps/adok/pages/reports').then((m) => m.ReportsPage)

const reportsRoutes: RouteRecordRaw[] = [
  {
    path: '/reports',
    component: Layout,
    name: 'reports',
    redirect: '/reports/full',
    children: [
      {
        path: ':tab',
        name: 'reports-tab',
        component: ReportsPage,
        meta: {
          title: 'Reports'
        }
      },
      {
        path: ':tab/:jid',
        name: 'reports-tab-result',
        component: ReportsPage,
        meta: {
          title: 'Reports',
          hidden: true
        }
      }
    ]
  }
]

export default reportsRoutes
